import { render, staticRenderFns } from "./ConfirmAppointment.vue?vue&type=template&id=486b63fc"
import script from "./ConfirmAppointment.vue?vue&type=script&lang=js"
export * from "./ConfirmAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports